import { Message } from 'element-ui';
import { queryScoreOverview } from '@/service';
/**
 * state(类似存储全局变量的数据)
 * getters(提供用来获取state数据的方法)
 * actions(提供跟后台接口打交道的方法， 并调用mutations提供的方法)
 * mutations(提供存储设置state数据的方法)
 */
let state = {
  score: {},
}
let getters = {
  allscore: state => state.score.points ? state.score.points : 0,
}
let mutations = {
  setScore(state, val) {
    state.score = val;
  },
}
let actions = {
  setScoreAsync(context) {
    queryScoreOverview().then((res) => {
      if (res.code != 200) {
        Message({
          showClose: true,
          message: res.message,
          type: 'error',
          duration: 2 * 1000
        })
        return;
      }
      context.commit('setScore', res.data);
    });
  },
}
export default {
  namespaced: true, // namespaced 属性，限定命名空间
  state,
  getters,
  mutations,
  actions
}